/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: {
        expandContentPaddingRight: 24,
        listMarginLeft: 2,
        titlePaddingLeft: 2
      }
    },
    {
      if: { expanded: true },
      tokens: { icon: PaletteIconChevronUp }
    },
    {
      if: { hover: true },
      tokens: {
        iconBackgroundColor: '#000000',
        iconColor: '#ffffff',
        iconOuterBorderGap: 2
      }
    },
    {
      if: { pressed: true },
      tokens: {
        iconBackgroundColor: '#404040',
        iconColor: '#ffffff',
        iconOuterBorderGap: 2
      }
    },
    {
      if: { focus: true },
      tokens: {
        iconOuterBorderColor: '#000000',
        iconOuterBorderGap: 2,
        iconOuterBorderWidth: 1
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: {
        iconBackgroundColor: '#404040',
        iconColor: '#666666',
        iconOuterBorderGap: 2
      }
    }
  ],
  tokens: {
    contentBorderColor: 'transparent',
    contentMarginBottom: 0,
    contentPaddingBottom: 8,
    contentPaddingLeft: 16,
    dividerColor: '#c9c8c8',
    expandBaseBorderWidth: 0,
    expandContentPaddingBottom: 16,
    expandContentPaddingLeft: 16,
    expandContentPaddingRight: 16,
    expandContentPaddingTop: 16,
    expandIconContainerAlignItems: 'center',
    expandIconContainerBorder: 0,
    expandIconContainerBorderColor: 'rgba(0, 0, 0, 0)',
    expandIconContainerHeight: 32,
    expandIconContainerJustifyContent: 'center',
    expandIconContainerMarginX: 0,
    expandIconContainerMarginY: 12,
    expandIconContainerWidth: 32,
    expandTitleBorder: 0,
    expandTitleBorderColor: 'rgba(0, 0, 0, 0)',
    expandTitleColor: '#000000',
    expandTitleFontName: 'StagSans',
    expandTitleFontSize: 16,
    expandTitleFontWeight: '600',
    expandTitleLineHeight: 1.5,
    expandTitleMarginX: 4,
    expandTitleMarginY: 0,
    expandTitlePaddingLeft: 0,
    expandTitleUnderline: 'none',
    headerBackgroundColor: 'rgba(0, 0, 0, 0)',
    icon: PaletteIconChevronDown,
    iconBackgroundColor: 'rgba(0, 0, 0, 0)',
    iconBorderColor: 'rgba(0, 0, 0, 0)',
    iconColor: '#000000',
    iconOuterBorderColor: 'rgba(0, 0, 0, 0)',
    iconOuterBorderGap: 0,
    iconOuterBorderWidth: 0,
    listColor: '#000000',
    listFontName: 'StagSans',
    listFontSize: 14,
    listFontWeight: '400',
    listLineHeight: 1.42857142857,
    listMarginBottom: 16,
    listMarginLeft: 32,
    mdContentPaddingBottom: 16,
    mdContentPaddingLeft: 48,
    orderedPadding: 0,
    titleColor: '#016b6a',
    titleFontSize: 14,
    titleLineHeight: 1.42857142857,
    titlePaddingLeft: 32,
    unorderedPadding: 12
  }
}
export default theme
